import { pickBy } from '@/utils'
import AttrItem from './attr-item'

export default {
  name: 'slider',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '分享拼單' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '分享有好禮，拼單更便宜' },
    // { label: '標題顏色', key: 'WordColor', component: 'color', value: '#333333' },
    {
      label: '輪播時間',
      key: 'interval',
      component: 'number',
      value: 3000,
      min: 1000,
      max: 50000,
      step: 1000
    },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    { label: '圓角圖片', key: 'rounded', component: 'switch', value: false },
    {
      label: '指示點樣式',
      key: 'dot',
      component: 'radio',
      options: [
        { name: '點', label: true },
        { name: '數字', label: false }
      ],
      value: true
    },
    { label: '指示點覆蓋', key: 'dotCover', component: 'switch', value: false },
    {
      label: '指示點位置',
      key: 'dotLocation',
      component: 'radio',
      options: [
        { name: '居左', label: 'left' },
        { name: '居中', label: 'center' },
        { name: '居右', label: 'right' }
      ],
      value: 'right'
    },
    {
      label: '指示點形狀',
      key: 'shape',
      component: 'radio',
      options: [
        { name: '圓形', label: 'circle' },
        { name: '長方型', label: 'rectangle' }
      ],
      value: 'circle'
    },
    {
      label: '指示點顏色',
      key: 'dotColor',
      component: 'radio',
      options: [
        { name: '深色', label: 'dark' },
        { name: '亮色', label: 'light' }
      ],
      value: 'dark'
    },
    { label: '輪播項間距', key: 'itemPadded', component: 'switch', value: true },
    // { label: '圖片描述', key: 'content', component: 'switch', value: true },
    {
      label: '輪播項',
      key: 'data',
      component: function (h, { key }) {
        return <AttrItem v-model={this.value[key]} />
      },
      value: [
        {
          button: '',
          content: '',
          id: '',
          imgUrl: '',
          linkPage: '',
          mainTitle: '',
          subtitle: '',
          subtitleTow: '',
          template: ''
        }
      ]
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data } = v
    return {
      name,
      ...base,
      ...config,
      data
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          interval: 'interval',
          dot: 'dot',
          dotLocation: 'dotLocation',
          dotColor: 'dotColor',
          shape: 'shape',
          dotCover: 'dotCover',
          rounded: 'rounded',
          content: 'content'
        })
      },
      data: 'data'
    })
  }
}
